import { z } from "zod";
import { SubSchema } from "../paywall-js";
/**
 * Messages consumed by "web-paywall-js"
 */ const WebPaywallEditorSetSubstitutions = z.object({
    name: z.literal("observe-substitutions"),
    substitutions: z.array(SubSchema)
});
export const WebPaywallEditorMessageSchema = z.discriminatedUnion("name", [
    WebPaywallEditorSetSubstitutions
]);
export const WrappedWebPaywallEditorMessageSchema = z.object({
    _type: z.literal("sw-web-paywall-editor"),
    version: z.literal(1),
    events: z.array(WebPaywallEditorMessageSchema)
});
